<script>
	export let onDownload = null;
	export let onCopy = null;
	export let copied = false;
	export let canCopy = true;
	export let busy = false;
	export let ready = false;
</script>

<div class="toolbar">
	<button type="button" disabled={busy || !ready} on:click={() => onDownload && onDownload()}>
		<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
		{busy ? "Se descarcă…" : "Descarcă PNG"}
	</button>
	{#if canCopy}
		<button type="button" disabled={!ready} on:click={() => onCopy && onCopy()}>
			<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>
			{copied ? "Link copiat" : "Copiază link"}
		</button>
	{/if}
</div>

<style>
	.toolbar {
		display: flex;
		flex-wrap: wrap;
		gap: 4px 10px;
		min-width: 0;
	}

	button {
		appearance: none;
		background: none;
		border: 0;
		padding: 8px 6px;
		min-height: 44px;
		box-sizing: border-box;
		font: inherit;
		font-size: 13px;
		color: var(--_ink-muted);
		display: inline-flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		border-radius: 3px;
	}

	button:hover {
		color: var(--_ink);
	}

	button:focus-visible {
		outline: 2px solid var(--_accent);
		outline-offset: 1px;
	}

	button[disabled] {
		opacity: 0.5;
		cursor: default;
	}

	button:hover:not(:disabled) { background: var(--_wash); }
</style>
